import React from "react";
import { Box, Typography } from "@mui/material";
import { InfoTooltip } from "components";
import { rowLabelSx } from "../styles";

export interface LabelWithTooltipProps {
  title: string;
  tooltipMessage: string;
  required?: boolean;
}

export const LabelWithTooltip = ({ title, tooltipMessage, required }: LabelWithTooltipProps) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ...rowLabelSx }}>
    <Typography sx={{ fontSize: "12px", color: "black", fontWeight: 600 }}>{title}</Typography>
    {required && <Typography component="span" sx={{ fontSize: "12px", color: "red", fontWeight: 600 }}> *</Typography>}
    <InfoTooltip tooltip={tooltipMessage} width="12" height="12" />
  </Box>
);
